import React from 'react';
import { string, number } from 'prop-types';
import Loader from '../Loader';
import './index.scss';

const YoutubePlayer = ({ width, height, autoPlay, videoId }) => (
    <div className="youtube-video">
        <div className="loader-wrapper">
            <Loader />
        </div>
        <iframe
            width={width}
            height={height}
            src={`https://www.youtube.com/embed/${videoId}?autoplay=${autoPlay}`}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        ></iframe>
    </div>
);

YoutubePlayer.propTypes = {
    videoId: string.isRequired,
    width: number,
    height: number,
    autoPlay: number,
};
YoutubePlayer.defaultProps = {
    width: 988,
    height: 560,
    autoPlay: 1,
};

export default YoutubePlayer;
